import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAqtpHtQE2vmcO57736wPi1nIlta1-T45g",
  authDomain: "lotto-12789.firebaseapp.com",
  projectId: "lotto-12789",
  storageBucket: "lotto-12789.firebasestorage.app",
  messagingSenderId: "649110382973",
  appId: "1:649110382973:web:66b99d5f931f7b52b50414",
  measurementId: "G-B4F8MX6XBY",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
